import * as React from 'react';
import { EmptyList } from '../../../components/SavedSearches/EmptyList';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../selectors';

export const EmptyListContainer: React.FC = () => {
  const { isAuthenticated } = useSelector(selectUser);

  const handleSearchClick = React.useCallback(() => {
    if (isAuthenticated) {
      window.location.href = 'https://cian.ru/';
    } else {
      if (window.hasOwnProperty('waitForLoginPopup')) {
        window.waitForLoginPopup();
      }
    }
  }, [isAuthenticated]);

  return <EmptyList isAuthenticated={isAuthenticated} onClick={handleSearchClick} />;
};
